<template>
    <div class="list">
        <div class="info df aic">
            <div @click="handleOpenavatar(item)" class="df cup">
                <el-avatar :size="24" :src="item.user_avatar_url" @error="true">
                    <img src="@/assets/images/avatar.png" alt="">
                </el-avatar>
            </div>

            <span class="name">{{ item.is_expert == 10 && false ?  (item.user_name == "" ? item.user_nick_name: item.user_name) : item.user_nick_name }}
                <span class="iconfont fs-14 c-9">&#xe60a;</span>{{
                parentItem.user_id == item.to_user_id && parentItem.tpa_type == 20 ? $t("匿名用户") : item.to_user_nick_name }}
            </span>
                <!-- 版主评论和版主点赞 -->
          <div class="moderator-box ml-12 df">
              <!-- 评论 icon-pinglun      点赞 icon-dianzan_kuai  -->
              <template v-if="item.data_is_moderator && item.tpa_type == 10">
                <div class="box-1"><span class="iconfont icon-pinglun"></span></div>
                <div class="box-2">{{ $t('版主评论') }}</div>
              </template>
              <template v-if="item.data_have_be_moderator_like">
                <div class="box-1"><span class="iconfont icon-dianzan_kuai"></span></div>
                <div class="box-2">{{ $t('版主点赞') }}</div>
              </template>
          </div>
        </div>
        <!-- 精华 -->
        <div class="essence-box" v-if="item.tpa_rec == 900">
          <img :src="require('@/assets/images/essence-'+currentLanguge+'.png')" alt="">
        </div>
        <div class="desc" v-html="item.tpa_content">
        </div>



        <div class="like-box df aic jcsb">

          <div class="pl-36">
            <span class="c-6 fs-14">{{ item.create_time }}</span>
          </div>
          <div class="df jcfe">
            <template v-if="is_moderator == 10">
              <el-button type="text" @click="handleEssence(item)" class="df aic" v-throttle="1000" :class="{ 'have_like': item.tpa_rec == 900 }">
                <span class="iconfont icon-jiangbei"></span>
                <span class="hava-text">
                    {{ item.tpa_rec == 900 ? $t('取消精华评论') : $t('置为精华评论') }}
                </span>
              </el-button>
            </template>
            <el-button type="text" class="df aic" @click="handleReplyPer(item)" v-throttle="1000">
                <img src="@/assets/images/path1.png" alt="">{{ $t('回复') }}
            </el-button>
            
            <el-button type="text" class="df aic" :class="{ 'have_like': item.data_have_be_like }"
                @click="handleactQuestionLike(item)" v-throttle="1000" :loading="item.is_loading">
                <span class="iconfont">{{ item.data_have_be_like ? '&#xe656;' : '&#xe61b;' }}</span>{{ item.tpa_likes ? item.tpa_likes : $t('点赞') }}
            </el-button>
            <el-button v-if="userinfo.user_id == item.user_id" type="text" class="df aic" v-throttle="1000" @click="handleDelete(item)"
                       :loading="item.delete_loading">
              <span class="iconfont fs-15">&#xe622;</span>{{ $t('删除') }}
            </el-button>
          </div>
        </div>
        <!-- 递归调用自身 -->
        <div v-if="item.children && item.children.length > 0">
            <comment-list v-for="(childItem, childIndex) in item.children" :key="childIndex" :item="childItem" :userinfo="userinfo"
                :handleReplyPer="handleReplyPer" :handleactQuestionLike="handleactQuestionLike" :handleEssence="handleEssence" :handleDelete="handleDelete" :is_moderator="is_moderator" />
        </div>

        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="id" />

    </div>
</template>

<script>
import { setuserfollowAdd } from "@api/home";
import {essencePostAns} from "@api/post";
export default {
    name: 'CommentList',
    props: {
        userinfo: {
          type: [Array, Object],  // 接受Array或Object
          required: true
        },
        item: {
            type: Object,
            default: () => {
                return {} 
            }
        },
        parentItem: {
            type: Object,
            default: () => {
                return {} 
            }
        },
        isAnonymous:{
            type: Boolean,
            default: false
        },
        handleReplyPer: {
            type: Function,
            required: true
        },
        handleactQuestionLike: {
            type: Function,
            required: true
        },
        handleEssence: {
            type: Function,
            required: true
        },
        handleDelete: {
          type: Function,
          required: true
        },
        is_moderator: {
            type: Number,
            default: 20
        }
    },
    data() {
        return {
            currentLanguge: localStorage.getItem('currentLanguage') || 'zh',
            id: 0,
        }
    },

    methods: {
        handleOpenavatar(item) {
            if (item.user_id == 0 || item.user_id == null || item.user_nick_name == 0 || item.user_nick_name == null) {
                return false;
            }
            this.$refs.avatarDialog.openModal();
            this.id = item.user_id;
        },
        // 个人信息谈款
        async handleAvatarSubmitted(id) {

            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);

            }

        },
    }
}
</script>

<style lang="scss" scoped>
.essence-box {
    position: absolute;
    right: 24px;
    top: -10px;
}
.moderator-box {
    height: 23px;
    line-height: 22px;

    .box-1 {
        // 背景渐变FFA547
        background: linear-gradient(180deg, #FF8B29 0%, #FFA547 100%);
        // background: #FF8E2D;
        padding: 0 16px 0 6px;
        border-radius: 8px 0 0 0;

        .iconfont {
            font-size: 14px;
            position: relative;
            top: -1px;
            color: #ffffff;
        }
    }

    .box-2 {
        background: #FAEAD7;
        position: relative;
        left: -10px;
        color: #FF8E2D;
        font-size: 12px;
        padding: 0 10px;
        border-radius: 12px 0 8px 0;
        border-left: 1px solid #ffffff;
    }
}
.list {
    margin-top: 16px;
    position: relative;
    &>div>.list {
        margin-top: 8px;
        // padding-left: 40px;
    }

    .info {
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .name {
            margin-left: 12px;
            font-family: "MicrosoftYaHeiSemibold";
        }
    }

    .desc {
        margin-left: 36px;
        color: rgb(25, 25, 25);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 14px;
        ::v-deep() {
            a {
                color: #00e;
            }
        }
    }

    .like-box {
        margin-top: 8px;

        button {
            color: rgb(174, 174, 174);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            padding: 0 8px;

            &.have_like {
                color: rgb(216, 15, 5);
                ;
            }

            img,
            .iconfont {
                width: 16px;
                margin-right: 8px;
            }

            &:hover {
                color: rgb(216, 15, 5);
                ;

            }
        }

        .el-button+.el-button {
            margin-left: 0;
        }
    }
}
</style>